<template>
  <div class="ex-wrap">
    <div class="header">
      <img class="title-img" src="../../assets/header.png" />
      <el-form :inline="true" :model="form" class="demo-form-inline">
        <el-form-item label="在线情况:">
          <el-button type="primary" class="qb" @click="chooseState(0)">全部</el-button>
          <el-button type="primary" class="wsj" @click="chooseState(1)">无数据</el-button>
          <el-button type="primary" class="qzx" @click="chooseState(2)">全在线</el-button>
          <el-button type="primary" class="qlx" @click="chooseState(3)">全离线</el-button>
          <el-button type="primary" class="swlx" @click="chooseState(4)">业务平台离线</el-button>
          <el-button type="primary" class="xwlx" @click="chooseState(5)">下位点位离线</el-button>
        </el-form-item>
        <el-form-item label="平台名称:">
          <select2
            v-model="form.PlatformName"
            url="platform"
            labelName="PlatformName"
            valueKey="PlatformName"
            placeholder
            no-data-text="无平台"
            style="width:180px;"
          ></select2>
        </el-form-item>
        <el-form-item label="MN号:">
          <el-input v-model="form.MN" style="width:180px;"></el-input>
        </el-form-item>
        <!-- <el-form-item label="业务类型:">
          <select2
            v-model="form.BusinessTypeID"
            url="basic?type=BusinessType"
            placeholder
            noDataText="无类型"
          ></select2>
        </el-form-item>
        <el-form-item label="是否报警:">
          <el-select v-model="form.Alarm" placeholder>
            <el-option label="是" value="true"></el-option>
            <el-option label="否" value="false"></el-option>
          </el-select>
        </el-form-item> -->
        <el-button @click="onSubmit">
          <i class="fas fa-search"></i>
        </el-button>
      </el-form>
      <img src="@/assets/cut.png" width="100%" />
    </div>
    <div class="main-main">
      <el-row :gutter="20">
        <el-col class="sf" v-for="item in itemList" :key="item.ID">
          <el-card>
            <el-row>
              <el-col
                :span="2"
                :class="{ 'light-gray': item.UpperActHourCnt===0&&item.DownActHourCnt===0,
                  'green': item.UpperHeartBeat===true&&item.DownHeartBeat===true
                    &&!(item.UpperActHourCnt===0&&item.DownActHourCnt===0),
                  'red': item.UpperHeartBeat===false&&item.DownHeartBeat===false
                    &&!(item.UpperActHourCnt===0&&item.DownActHourCnt===0),
                  'yellow': item.UpperHeartBeat===false&&item.DownHeartBeat===true
                    &&!(item.UpperActHourCnt===0&&item.DownActHourCnt===0),
                  'orange': item.UpperHeartBeat===true&&item.DownHeartBeat===false
                    &&!(item.UpperActHourCnt===0&&item.DownActHourCnt===0)}"
                style="text-align:center;"
              >
                <i class="fas fa-map-marker"></i>
              </el-col>
              <el-col :span="22" class="white station-name cut-long">
                <el-tooltip effect="dark" :content="item.StationName" placement="top-start">
                  <span>{{item.StationName}}</span>
                </el-tooltip>
              </el-col>
            </el-row>
            <el-row style="margin:0.6vh 0;">
              <el-col :span="2" class="blue" style="text-align:center;margin-top:2px;">
                <i class="fas fa-desktop"></i>
              </el-col>
              <el-col :span="18" class="blue cut-long" style="margin-top:2px;">
                {{item.PlatformName}}
              </el-col>
              <el-col :span="4" class="red alarm">
                <el-col :span="10" style="text-align:center;" class="alarm-icon">
                  <i class="fas fa-bell"></i>
                </el-col>
                <el-col :span="14" class="alarm-number">{{item.WarnNumber}}</el-col>
              </el-col>
            </el-row>
            <el-row class="gray" style="margin:0.6vh 0;">
              每日小时数据条数
            </el-row>
            <el-row
              :class="{ 'light-gray': item.UpperActHourCnt===0&&item.DownActHourCnt===0,
                  'green': item.UpperHeartBeat===true&&item.DownHeartBeat===true
                  &&!(item.UpperActHourCnt===0&&item.DownActHourCnt===0),
                  'red': item.UpperHeartBeat===false&&item.DownHeartBeat===false
                  &&!(item.UpperActHourCnt===0&&item.DownActHourCnt===0),
                  'yellow': item.UpperHeartBeat===false&&item.DownHeartBeat===true
                  &&!(item.UpperActHourCnt===0&&item.DownActHourCnt===0),
                  'orange': item.UpperHeartBeat===true&&item.DownHeartBeat===false
                  &&!(item.UpperActHourCnt===0&&item.DownActHourCnt===0)}"
            >
              <el-col class="sp1" style="font-size:14px;">上位</el-col>
              <el-col class="sp2 num">
                <span class="numbg">{{parseInt(item.UpperActHourCnt/10)}}</span>
                <span class="numbg">{{item.UpperActHourCnt%10}}</span>
              </el-col>
              <el-col class="sp1" style="font-size:14px;">下位</el-col>
              <el-col class="sp2 num">
                <span class="numbg">{{parseInt(item.DownActHourCnt/10)}}</span>
                <span class="numbg">{{item.DownActHourCnt%10}}</span>
              </el-col>
              <el-col class="is-show">
                <el-row class="gray" style="font-size:13px;">数据时间</el-row>
                <el-row class="time cut-long">
                  <div
                    v-if="item.DownLatestHourTime"
                  >{{item.DownLatestHourTime.substring(5,13).replace("T"," ")}}</div>
                  <div v-else>/</div>
                </el-row>
              </el-col>
            </el-row>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      form: {
        PlatformName: null,
        MN: null,
        UpperActHourCnt: null,
        DownActHourCnt: null,
        UpperHeartBeat: null,
        DownHeartBeat: null,
        // BusinessTypeID: null,
      },
      itemList: [],
      isShow: false,
    };
  },
  mounted() {
    this.getItemList();
  },
  methods: {
    getItemList() {
      this.$axios.get('visualinterface', {
        params: {
          where: this.form,
        },
      })
        .then((response) => {
          this.itemList = response.data;
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        });
    },
    chooseState(flag) {
      switch (flag) {
        case 0: {
          this.form.UpperActHourCnt = null;
          this.form.DownActHourCnt = null;
          this.form.UpperHeartBeat = null;
          this.form.DownHeartBeat = null;
          break;
        }
        case 1: {
          this.form.UpperActHourCnt = 0;
          this.form.DownActHourCnt = 0;
          this.form.UpperHeartBeat = null;
          this.form.DownHeartBeat = null;
          break;
        }
        case 2: {
          this.form.UpperActHourCnt = null;
          this.form.DownActHourCnt = null;
          this.form.UpperHeartBeat = true;
          this.form.DownHeartBeat = true;
          break;
        }
        case 3: {
          this.form.UpperActHourCnt = null;
          this.form.DownActHourCnt = null;
          this.form.UpperHeartBeat = false;
          this.form.DownHeartBeat = false;
          break;
        }
        case 4: {
          this.form.UpperActHourCnt = null;
          this.form.DownActHourCnt = null;
          this.form.UpperHeartBeat = false;
          this.form.DownHeartBeat = true;
          break;
        }
        case 5: {
          this.form.UpperActHourCnt = null;
          this.form.DownActHourCnt = null;
          this.form.UpperHeartBeat = true;
          this.form.DownHeartBeat = false;
          break;
        }
        default: {
          this.form.UpperActHourCnt = null;
          this.form.DownActHourCnt = null;
          this.form.UpperHeartBeat = null;
          this.form.DownHeartBeat = null;
        }
      }
      this.getItemList();
    },
    onSubmit() {
      this.getItemList();
    },
  },
};
</script>

<style lang="scss" scope>
.cut-long {
    white-space:nowrap;
    overflow:hidden;
    text-overflow:ellipsis;
  }
.ex-wrap {
  min-height: 100vh;
  background-color: #0c1417;
  padding: 0px 20px 0px 20px;
  .header {
    text-align: center;
    .box {
      background: url("/src/assets/header.png") no-repeat center; //center最重要
    }
    .title-img {
      margin-top: 2vh;
      margin-bottom: 3vh;
      width: 100%;
    }
    .el-form-item__label {
      font-size: 16px;
      color: #cdcdcd;
    }
    .el-input__inner {
      font-size: 16px;
      border-radius: 3px;
      color: #cdcdcd;
      background-color: #111d1d;
      border-color: #111d1d;
    }
    .el-button {
      font-size: 16px;
      border-radius: 5px;
    }
    .el-button--default {
      border-color: #111d1d;
      border-radius: 5px;
      background-color: #111d1d;
      color: #ffffff;
    }
    .el-button:focus {
      background-color: #ffffff;
      color: #0c1417;
    }
    .el-button:hover {
      background-color: #fff;
      color: #0c1417;
    }
    .el-select {
      width: 220px;
    }
    .select2 {
      width: 220px;
    }
    .qb {
      background-color: #111d1d;
      border-color: #b5c3ca;
    }
    .wsj {
      background-color: #b5c3ca;
      border-color: #b5c3ca;
      color: #111d1d;
    }
    .qzx {
      background-color: #3ec96f;
      border-color: #3ec96f;
    }
    .qlx {
      background-color: #ee2341;
      border-color: #ee2341;
    }
    .swlx {
      background-color: #fbcd2b;
      border-color: #fbcd2b;
      color: #111d1d;
    }
    .xwlx {
      background-color: #fb702b;
      border-color: #fb702b;
    }
  }
  .main-main {
    font-size: 16px;
    .el-card {
      margin-top: 0.9vh;
      margin-bottom: 0.7vh;
      border-radius: 12px;
      background-color: #0c1417;
    }
    .white {
      color: #dddddd;
    }
    .gray {
      color: #7a7e80;
    }
    .light-gray {
      color: #b5c3ca;
    }
    .green {
      color: #3ec96f;
    }
    .red {
      color: #bd2341;
    }
    .blue {
      color: #00a1fe;
    }
    .yellow {
      color: #fbcd2b;
    }
    .orange {
      color: #fb702b;
    }
    @font-face {
      font-family: "LED";
      src: url("/src/assets/fonts/led.ttf") format("truetype");
      font-weight: normal;
      font-style: normal;
    }
    .big {
      width: 20%;
      font-size: 16px;
      .station-name {
        font-size: 18px;
      }
      .time {
        font-family: LED;
        font-size: 22px;
      }
      .num {
        font-family: LED;
        font-size: 30px;
      }
      .numbg {
        float: left;
        background-color: #181918;
        width: 30px;
        margin-right: 1px;
        margin-top: 8px;
        text-align: center;
      }
      .alarm {
        border: 1px solid;
        border-radius: 45px;
        .alarm-icon {
          border: 1px solid;
          border-radius: 45px;
        }
        .alarm-number {
          float: left;
          text-align: center;
          font-family: LED;
          font-size: 20px;
          padding-top: 3px;
        }
      }
      .sp1 {
        width: 5%;
      }
      .sp2 {
        width: 30%;
      }
      .is-show {
        width: 30%;
      }
    }
    .medium {
      width: 12.5%;
      font-size: 10px;
      .station-name {
        font-size: 12px;
      }
      .time {
        font-family: LED;
        font-size: 14px;
      }
      .num {
        font-family: LED;
        font-size: 16px;
      }
      .numbg {
        float: left;
        background-color: #181918;
        width: 16px;
        margin-right: 1px;
        margin-top: 8px;
        text-align: center;
      }
      .alarm {
        border: 1px solid;
        border-radius: 45px;
        .alarm-icon {
          border: 1px solid;
          border-radius: 45px;
        }
        .alarm-number {
          float: left;
          text-align: center;
          font-family: LED;
          font-size: 14px;
          padding-top: 3px;
        }
      }
      .sp1 {
        width: 20%;
      }
      .sp2 {
        width: 30%;
      }
      .is-show {
        display: none;
      }
    }
    .small {
      width: 8.3%;
      font-size: 8px;
      .station-name {
        font-size: 12px;
      }
      .time {
        font-family: LED;
        font-size: 14px;
      }
      .num {
        font-family: LED;
        font-size: 16px;
      }
      .numbg {
        float: left;
        background-color: #181918;
        width: 16px;
        margin-right: 1px;
        margin-top: 8px;
        text-align: center;
      }
      .alarm {
        border: 1px solid;
        border-radius: 45px;
        .alarm-icon {
          border: 1px solid;
          border-radius: 45px;
        }
        .alarm-number {
          float: left;
          text-align: center;
          font-family: LED;
          font-size: 14px;
          padding-top: 3px;
        }
      }
      .sp1 {
        width: 20%;
      }
      .sp2 {
        width: 30%;
      }
      .is-show {
        display: none;
      }
    }
    .sf {
      width: 20%;
      font-size: 16px;
      .station-name {
        font-size: 18px;
      }
      .time {
        font-family: LED;
        font-size: 22px;
      }
      .num {
        font-family: LED;
        font-size: 30px;
      }
      .numbg {
        float: left;
        background-color: #181918;
        width: 30px;
        margin-right: 1px;
        margin-top: 8px;
        text-align: center;
      }
      .alarm {
        border: 1px solid;
        border-radius: 45px;
        .alarm-icon {
          border: 1px solid;
          border-radius: 45px;
        }
        .alarm-number {
          float: left;
          text-align: center;
          font-family: LED;
          font-size: 20px;
          padding-top: 3px;
        }
      }
      .sp1 {
        width: 5%;
      }
      .sp2 {
        width: 30%;
      }
      .is-show {
        width: 30%;
      }
    }
    @media (max-width: 1300px) {
    .sf {
      width: 25%;
      font-size: 16px;
      .station-name {
        font-size: 18px;
      }
      .time {
        font-family: LED;
        font-size: 22px;
      }
      .num {
        font-family: LED;
        font-size: 30px;
      }
      .numbg {
        float: left;
        background-color: #181918;
        width: 30px;
        margin-right: 1px;
        margin-top: 8px;
        text-align: center;
      }
      .alarm {
        border: 1px solid;
        border-radius: 45px;
        .alarm-icon {
          border: 1px solid;
          border-radius: 45px;
        }
        .alarm-number {
          float: left;
          text-align: center;
          font-family: LED;
          font-size: 20px;
          padding-top: 3px;
        }
      }
      .sp1 {
        width: 5%;
      }
      .sp2 {
        width: 30%;
      }
      .is-show {
        width: 30%;
      }
    }
    }
    @media (min-width: 2560px) {
      .sf {
        width: 12.5%;
        font-size: 10px;
        .station-name {
          font-size: 12px;
        }
        .time {
          font-family: LED;
          font-size: 14px;
        }
        .num {
          font-family: LED;
          font-size: 16px;
        }
        .numbg {
          float: left;
          background-color: #181918;
          width: 16px;
          margin-right: 1px;
          margin-top: 8px;
          text-align: center;
        }
        .alarm {
          border: 1px solid;
          border-radius: 45px;
          .alarm-icon {
            border: 1px solid;
            border-radius: 45px;
          }
          .alarm-number {
            float: left;
            text-align: center;
            font-family: LED;
            font-size: 14px;
            padding-top: 3px;
          }
        }
        .sp1 {
          width: 20%;
        }
        .sp2 {
          width: 30%;
        }
        .is-show {
          display: none;
        }
      }
    }
    @media (min-width: 3840px) {
      .sf {
        width: 8.3%;
        font-size: 6px;
        .station-name {
          font-size: 12px;
        }
        .time {
          font-family: LED;
          font-size: 14px;
        }
        .num {
          font-family: LED;
          font-size: 16px;
        }
        .numbg {
          float: left;
          background-color: #181918;
          width: 16px;
          margin-right: 1px;
          margin-top: 8px;
          text-align: center;
        }
        .alarm {
          border: 1px solid;
          border-radius: 45px;
          .alarm-icon {
            border: 1px solid;
            border-radius: 45px;
          }
          .alarm-number {
            float: left;
            text-align: center;
            font-family: LED;
            font-size: 14px;
            padding-top: 3px;
          }
        }
        .sp1 {
          width: 25%;
        }
        .sp2 {
          width: 25%;
        }
        .is-show {
          display: none;
        }
        .el-card {
          border-width: 2px;
        }
      }
    }
    @media (min-width: 7680px) {
      .sf {
        width: 6.6%;
        font-size: 6px;
        .station-name {
          font-size: 12px;
        }
        .time {
          font-family: LED;
          font-size: 14px;
        }
        .num {
          font-family: LED;
          font-size: 16px;
        }
        .numbg {
          float: left;
          background-color: #181918;
          width: 16px;
          margin-right: 1px;
          margin-top: 8px;
          text-align: center;
        }
        .alarm {
          border: 1px solid;
          border-radius: 45px;
          .alarm-icon {
            border: 1px solid;
            border-radius: 45px;
          }
          .alarm-number {
            float: left;
            text-align: center;
            font-family: LED;
            font-size: 14px;
            padding-top: 3px;
          }
        }
        .sp1 {
          width: 25%;
        }
        .sp2 {
          width: 25%;
        }
        .is-show {
          display: none;
        }
        .el-card {
          border-width: 2px;
        }
      }
    }
  }
}
</style>
